module.exports = __webpack_public_path__ + "static/paris-018-8c966359e421e8456a60d601b9ff0ea7.jpg";